import { DashboardEnhancements } from '../DashboardEnhancements.js';
import { ErrorHandler } from '../utils/error-handler.js';

/**
 * Fetch latest collections for the active user with current filters.
 * @returns {Promise<void>}
 */
export async function loadCollections() {
    if (this.isLoading) return;

    this.showLoadingState();
    this.isLoading = true;

    try {
        const params = {
            page: this.currentPage,
            per_page: this.perPage,
            ...this.currentFilters
        };

        if (params.sort) {
            const sortMap = {
                'created_desc': { orderby: 'created_at', order: 'desc' },
                'created_asc': { orderby: 'created_at', order: 'asc' },
                'name_asc': { orderby: 'name', order: 'asc' },
                'name_desc': { orderby: 'name', order: 'desc' },
                'updated_desc': { orderby: 'updated_at', order: 'desc' },
                'updated_asc': { orderby: 'updated_at', order: 'asc' },
                'items_desc': { orderby: 'item_count', order: 'desc' },
                'items_asc': { orderby: 'item_count', order: 'asc' },
                'views_desc': { orderby: 'view_count', order: 'desc' },
                'views_asc': { orderby: 'view_count', order: 'asc' }
            };

            const sortConfig = sortMap[params.sort] || sortMap['created_desc'];
            params.orderby = sortConfig.orderby;
            params.order = sortConfig.order;
            delete params.sort;
        }

        if (params.tags) {
            params.tag = params.tags;
            delete params.tags;
        }

        Object.keys(params).forEach((key) => {
            if (params[key] === '' || params[key] === null || params[key] === undefined) {
                delete params[key];
            }
        });

        const response = await this.api.listCollections(params);

        if (response && response.collections) {
            this.collections = response.collections || [];
            this.totalCollections = response.pagination?.total || 0;
            this.totalPages = response.pagination?.pages || 1;

            this.renderCollections();
            this.updatePagination();
            this.hideAllStates();

            if (this.collections.length === 0) {
                this.showEmptyState();
            }
        } else {
            throw new Error('Invalid response format');
        }
    } catch (error) {
        const message = ErrorHandler.extractMessage(error);
        ErrorHandler.handle(error, message);
        this.showErrorState(message);
    } finally {
        this.isLoading = false;
    }
}

/**
 * Render the collections list and warning indicators.
 * @returns {void}
 */
export function renderCollections() {
    if (typeof this.renderCollectionsList === 'function') {
        this.renderCollectionsList(this.collections);
    }

    DashboardEnhancements.checkCollectionSizeWarnings(this.collections);
}
